export default {
	about: 'About',
	mission: 'Our Mission',
	vision: 'Who we are',
	policy: 'Value Chain',
	qualityPolicy: 'Service Oriented'
}